import { SingleBillPaymentMethodsController, UpdateSingleBillController } from '../controllers';
import { initializerHelpers } from '../helpers';
import type { Listeners } from '../helpers';
import {
  SingleBillPaymentMethodsManager,
  SingleBillInfoFormManager,
  AlertManager,
  RouterNonUiManager,
  UpdateSingleBillManager,
} from '../managers';

export class SingleBillInitializer {
  public listeners: Listeners;

  // managers
  private singleBillInfoForm: SingleBillInfoFormManager;

  private singleBillPaymentMethods: SingleBillPaymentMethodsManager;

  private alert: AlertManager;

  private routerManager: RouterNonUiManager;

  private updateSingleBillManager: UpdateSingleBillManager;

  // init methods
  public singleBillInfoFormInit: SingleBillInfoFormManager['singleBillInfoFormInit'];

  public singleBillPaymentMethodsInit: SingleBillPaymentMethodsManager['singleBillPaymentMethodsInit'];

  public alertInit: AlertManager['alertInit'];

  public routerNonUiInit: RouterNonUiManager['routerNonUiInit'];

  public updateSingleBillInit: UpdateSingleBillManager['updateSingleBillInit'];

  constructor() {
    this.singleBillInfoForm = new SingleBillInfoFormManager();
    this.singleBillPaymentMethods = new SingleBillPaymentMethodsManager();
    this.alert = new AlertManager();
    this.routerManager = new RouterNonUiManager();
    this.updateSingleBillManager = new UpdateSingleBillManager();

    this.singleBillInfoFormInit = this.singleBillInfoForm.singleBillInfoFormInit;
    this.singleBillPaymentMethodsInit = this.singleBillPaymentMethods.singleBillPaymentMethodsInit;
    this.alertInit = this.alert.alertInit;
    this.routerNonUiInit = this.routerManager.routerNonUiInit;
    this.updateSingleBillInit = this.updateSingleBillManager.updateSingleBillInit;

    this.listeners = this.initializeControllers();
  }

  private initializeControllers() {
    const controllers = [
      new SingleBillPaymentMethodsController(this.updateSingleBillManager),
      new UpdateSingleBillController(
        this.singleBillPaymentMethods,
        this.singleBillInfoForm,
        this.updateSingleBillManager,
        this.alert
      ),
    ];

    initializerHelpers.initControllers(controllers);

    return initializerHelpers.createListeners(controllers);
  }
}
